import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '@/lib/utils';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef< typeof TooltipPrimitive.Content >,
  React.ComponentPropsWithoutRef< typeof TooltipPrimitive.Content >
>( ( { className, sideOffset = 4, ...props }, ref ) => (
  <TooltipPrimitive.Content
    ref={ ref }
    sideOffset={ sideOffset }
    className={ cn(
      'z-[11000] overflow-hidden rounded-sm',
      'px-3 py-1.5 text-sm shadow-md animate-in',
      'fade-in-0 zoom-in-95 data-[state=closed]:animate-out',
      'data-[state=closed]:fade-out-0',
      'data-[state=closed]:zoom-out-95',
      'data-[side=bottom]:slide-in-from-top-2',
      'data-[side=left]:slide-in-from-right-2',
      'data-[side=right]:slide-in-from-left-2',
      'data-[side=top]:slide-in-from-bottom-2',
      'bg-black text-brand-gray',
      className,
    ) }
    { ...props }
  />
) );
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

const AgentTooltip = ( {
  content,
  children,
  maxWidth = 250,
  ...props
}: {
  content: React.ReactNode;
  children: React.ReactNode;
  maxWidth?: number;
} & React.ComponentPropsWithoutRef< typeof TooltipPrimitive.Content > ) => {
  return (
    <TooltipProvider delayDuration={ 500 }>
      <Tooltip>
        <TooltipTrigger asChild>{ children }</TooltipTrigger>
        <TooltipContent { ...props } style={ { maxWidth } }>
          { content }
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, AgentTooltip };
